// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */

import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import S from './style';
import moment from 'moment';
import MemberContext from '../../../../contexts/MemberContext';
import { PopupPreviewProps } from '../Popup/Popup';
interface MassageProps {
  time: Date;
  username: string;
  message: string;
  imagesUrls: string[];
  setShowPreview: React.Dispatch<React.SetStateAction<{
    time: string;
    message: string;
    username: string;
    imagesUrls: string[];
    currentPhotoId: number;
  } | undefined>>
}
const UserMessage = (props: MassageProps): JSX.Element => {
  const intl = useIntl();
  const now = new Date().getTime();
  const member = useContext(MemberContext);
  const { time, username, imagesUrls, message, setShowPreview } = props;
  const setPreview = (index: number) => {
    setShowPreview({
      username,
      time: now - time.getTime() <= 86400000 ? `${moment(time).fromNow(true)}` + intl.formatMessage({ id: 'I026' }): moment(time).format('L'),
      imagesUrls,
      message,
      currentPhotoId: index
    })
  }
  return (
    <>
      <S.MessageWrapper >
        <S.Message>
          <S.Name>
            {username}
          </S.Name>
          <S.MessageText>
            {message}
          </S.MessageText>
          {imagesUrls && <S.MessageImages>
            {imagesUrls.map((data, index) => {
              return (
                <S.Image key={index} src={data} onClick={() => setPreview(index)}/>
              )
            })}
          </S.MessageImages>
          }
          <S.Time>
            {now - time.getTime() <= 86400000 ? `${moment(time).fromNow(true)}` + intl.formatMessage({ id: 'I026' }) : moment(time).format('L')}
          </S.Time>
        </S.Message>
        <S.AvatarWrapper>
          {
            !member.imageUrl || member.imageUrl === '' ?
              <S.Title>{member.username ? member.email[0].toUpperCase() : ''}</S.Title> :
              <S.Avatar src={member.imageUrl} />
          }
        </S.AvatarWrapper>
      </S.MessageWrapper>
    </>
  );
}

export { UserMessage as default }
